/**
 * supabase.ts · 09_APP · OS-006
 *
 * One client, identity only.
 *
 * ACCESS_AND_LOGIN_DECISION_2026-08-01: "Logging into the OS is a badge, not a
 * mailbox." Google sign-in supplies who somebody is. It requests identity
 * scopes only, which is a basic scope and does not trigger Google's app
 * verification. Mail never comes through a user's own grant; it comes through
 * C2C's single connection, which is not this app's business.
 *
 * The publishable anon key is the only key here. It is not a secret in the
 * usual sense: it identifies the project, and RLS decides what the bearer may
 * actually see. There is no service key in this codebase and there must never
 * be one.
 */

import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isConfigured = Boolean(url && anonKey);

/** Missing config must be a clear message on screen, never a blank page. */
export const configProblem = !url
  ? "VITE_SUPABASE_URL is not set."
  : !anonKey
    ? "VITE_SUPABASE_ANON_KEY is not set."
    : null;

export const supabase = createClient(url ?? "https://unconfigured.invalid", anonKey ?? "unconfigured", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export async function signInWithGoogle() {
  return supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: window.location.origin,
      // Identity only. No Gmail scopes, deliberately: decision 2, 2026-08-01.
      scopes: "openid email profile",
    },
  });
}

export async function signOut() {
  return supabase.auth.signOut();
}
